import { UseFormGetValues, UseFormResetField, UseFormSetError, UseFormSetValue } from "react-hook-form";
import { ActionInfo, ApiValues, DropdownField, Field, FieldLevelActionOperation, FormulaField } from "../../types/field";
import { AccessLevel, ActionVisibilityCriteria, ExtraRecordLevelActions, RowLevelAction } from "../../types/types";
import { getIndexOfPlatformAction, getIndexOfPlatformActionFromVal, getLoggedInUserEcode } from "../../utils/utils";
import { javascriptRecordActionFns } from "../../components/platformTableComponent/platformTableActionUtils";
import { javascriptRowActionFns } from "../../components/platformTableComponent/platformTableActionUtils";
import CustomRecordDetailModal from "../../components/modal/customRecordDetailModal";
import { downloadCall, GetRequest, replaceWithCurrentApiVersion } from "../../utils/api";


export type apiAliasMapper = {
  columnName: string;
  mapTo: string;
}

export type dataApiType = {
  criteria: string,
  api: string,
  mapping?: any
}

const fillUpWithFieldValues = (criteria: string, editForm: Field[], getValues: UseFormGetValues<any>): string => {

  let response = criteria;
  const values = getValues();

  editForm.forEach((field: Field) => {
    response = response.replaceAll("field." + field.field + " ", "'" + values[field.field] + "'");
  });


  return response;

}

export const fillUpWithFieldValuesAndParams = (criteria: string, editForm: Field[], getValues: UseFormGetValues<any>, urlparams: Map<string, string>): string => {

  let response = criteria;
  const values = getValues();

  editForm.forEach((field: Field) => {
    response = response.replaceAll("field." + field.field + " ", "'" + values[field.field] + "'");
  });

  urlparams.forEach((value: string, key: string) => {
    response = response.replaceAll("urlparam." + key + " ", "'" + value + "'");
  });

  response = response.replaceAll("loggedInUser.ecode", "'" + getLoggedInUserEcode() + "'");

  return response;
}

export const evaluateVisibilityOfAction = (action: ExtraRecordLevelActions, editForm: Field[], getValues: UseFormGetValues<any>, urlparams: Map<string, string>): boolean => {
  if (action.visibilityCriteria) {
    const criteria: ActionVisibilityCriteria = action.visibilityCriteria;
    if (criteria.computationType === 'javascript') {
      let expressionToEval = fillUpWithFieldValuesAndParams(criteria.expr ?? "", editForm, getValues, urlparams);
      if (expressionToEval.includes('urlparam')) {
        return false;
      }

      try {
        return eval(expressionToEval);
      } catch (err) {
        console.error(err);
        return false;
      }

    }
  }

  return true;
}

export const evaluateCriteria = (criteria: ActionVisibilityCriteria | undefined, editForm: Field[], getValues: UseFormGetValues<any>, urlparams: Map<string, string>): boolean => {
  if (criteria && criteria.computationType === 'javascript') {
    let expressionToEval = fillUpWithFieldValuesAndParams(criteria.expr ?? "", editForm, getValues, urlparams);
    if (expressionToEval.includes('urlparam')) {
      return false;
    }
    try {
      return eval(expressionToEval);
    } catch (err) {
      console.error(err);
      return false;
    }
  }
  return true;
}

export const getViewApi = (dataApis: dataApiType[] | undefined, dataApi: string, urlparams: Map<string, string>): string => {

  const vapi: dataApiType | undefined = dataApis?.find(dapi => {
    urlparams.forEach((value: string, key: string) => {
      dapi.criteria = dapi.criteria.replaceAll("urlparam." + key + " ", "'" + value + "'");
    });

    try {
      return eval(dapi.criteria);
    } catch (err) {
      console.error(err);
      return false;
    }



  });
  return vapi ? vapi.api : dataApi;
}

export const refreshFieldsBasedOnVisibility = (editForm: Field[], isCreateFlow: boolean,
  getValues: UseFormGetValues<any>,
  setValue: UseFormSetValue<any>,
  resetField: UseFormResetField<any>, formSchema: Field[]): Field[] => {
  return refreshFieldsBasedOnVisibilityChildForm(editForm, isCreateFlow, getValues, setValue, resetField, formSchema, editForm, undefined);
}

export const refreshFieldsBasedOnVisibilityChildForm = (editForm: Field[], isCreateFlow: boolean,
  getValues: UseFormGetValues<any>,
  setValue: UseFormSetValue<any>,
  resetField: UseFormResetField<any>, formSchema: Field[], parentFields: Field[], prefixToField: string | undefined): Field[] => {
  let tempForm: Field[] = [];

  if (editForm) {
    editForm.forEach((field: Field, index: number) => {
      let criteria = field.visibilityCriteria ?? "true";
      criteria = fillUpWithFieldValues(criteria, parentFields, getValues);
      if (eval(criteria) && ((field.showOnlyInCreate && isCreateFlow) || !field.showOnlyInCreate)) {
        let f = fetchExistingFieldOnFormIfAvailable(formSchema, { ...field });
        if (f.isChildForm) {
          let newChildFields = refreshFieldsBasedOnVisibilityChildForm(field.editFields ?? [], isCreateFlow, getValues, setValue, resetField, f?.editFields ?? [], editForm, f.field);
          f.editFields = newChildFields.map(cf => fetchExistingFieldOnFormIfAvailable(f?.editFields ?? [], cf));
        }

        if (f.fieldType === "subgroup") {
          refreshFieldsBasedOnVisibilityChildForm(field.childField ?? [], isCreateFlow, getValues, setValue, resetField, formSchema, editForm, undefined);
        }

        tempForm.push(f);
      } else {
        if (prefixToField) {
          const totalChildForms: number = getValues()[prefixToField]?.length ?? 0;
          for (let i = 0; i < totalChildForms; i++) {
            resetField(prefixToField + "[" + i + "]" + "[" + field.field + "]");
          }
        } else {
          resetField(field.field);
        }
      }
    });
  }
  return tempForm;
}


export const refreshFormulaFields = (editForm: Field[], getValues: UseFormGetValues<any>, setValue: UseFormSetValue<any>
  , parentFields: Field[]): Field[] => {
  let formulaFields: Field[] = [];
  if (editForm) {
    editForm.forEach((field: Field) => {

      if (field.fieldType === "subgroup") {
        let subFields: Field[] = refreshFormulaFields(field.childField ?? [], getValues, setValue, editForm);
        subFields.forEach((f: Field) => {
          formulaFields.push(f);
        });
      }

      if (field.fieldType === "formula") {
        let formula = (field as FormulaField).formula;
        if (formula) {
          let formulaAfterReplaceVals = fillUpWithFieldValues(formula, parentFields, getValues);
          const temp = eval(formulaAfterReplaceVals);
          if (temp && temp !== undefined && temp !== null) {
            if (typeof temp === "number") {
              setValue(field.field, temp.toString());
            } else {
              setValue(field.field, temp);
            }

          }

          formulaFields.push(field);
        }
      }
    });
  }
  return formulaFields;
}

export const getApiForField = (editForm: Field[], getValues: UseFormGetValues<any>, field: DropdownField): ApiValues => {

  let response: ApiValues = {
    api: field.api ?? "",
    criteria: " true ",
    dropdownCode: field?.dropdownCode,
    dropdownValue: field?.dropdownValue
  };

  if (field.apiExecutionCriteria && field.apiExecutionCriteria.type === "criteria-eval") {
    if (editForm) {
      field.apiExecutionCriteria?.values?.forEach((apiValue: ApiValues) => {
        let criteria = apiValue.criteria ?? "true";
        criteria = fillUpWithFieldValues(criteria, editForm, getValues);
        if (eval(criteria)) {
          response = {
            api: apiValue.api ?? "",
            criteria: apiValue.criteria,
            dropdownCode: apiValue.dropdownCode ?? field?.dropdownCode,
            dropdownValue: apiValue.dropdownValue ?? field?.dropdownValue
          }
        }
      });
    }
  }

  return response;
}

const fetchExistingFieldOnFormIfAvailable = (formSchema: Field[], newField: Field): Field => {

  let existingFieldOnForm = formSchema.find(oldFormField => oldFormField.field === newField.field);
  if (existingFieldOnForm) {
    return existingFieldOnForm;
  }
  return newField;
}

export const isFieldEditable = (field: Field, platformAction: RowLevelAction, isEditClicked: boolean, isCreateFlow: boolean): boolean => {

  if (field?.allowEdit) {
    let actions: string[] = field?.allowEdit;
    if (actions.length === 0) {
      return false;
    }
    let rowActions: RowLevelAction[] = [];
    actions.forEach(action => {
      rowActions.push(action.toUpperCase() as RowLevelAction);
    });

    if (getIndexOfPlatformAction(platformAction) === getIndexOfPlatformActionFromVal(RowLevelAction.EDIT)) {
      return (rowActions.find(action => action === platformAction) && isEditClicked) ? true : false;
    }

    return rowActions.find(action => action === platformAction) ? true : false;
  }
  if (isEditClicked && !isCreateFlow && field.updatable === false) {
    return false;
  }

  return ((isEditClicked && field?.editable) || isCreateFlow);
}

export const isMandatoryField = (field: Field, getValues: UseFormGetValues<any>, editForm: Field[]): boolean => {

  if (field?.rules && field?.rules[0]?.mandatoryCriteria) {
    let criteria = field?.rules[0]?.mandatoryCriteria ?? "false";
    criteria = fillUpWithFieldValues(criteria, editForm, getValues);

    try {
      return eval(criteria);
    } catch (err) {
      console.error(err);
      return false;
    }


  }

  return field?.rules && field?.rules[0]?.mandatory;
}

export const mapViewApiToAliasNames = (data: any, dataApiMapper?: apiAliasMapper[]): any => {
  if (data) {
    dataApiMapper?.forEach(mapper => {
      if (data[mapper.columnName]) {
        data[mapper.mapTo] = data[mapper.columnName];
      }
    });
  }
  return data;
}

export const getViewDataForChildField = (viewData: any, fieldId: string): any => {
  // Use regular expression to match and extract the parts
  const regex = /([^\[\]]+)\[(\d+)\]\.([^\[\].]+)/;
  const match = fieldId.match(regex);

  // Check if the input matches the expected format
  if (match) {
    const [parentFieldId, indexOfChild, childFieldId] = match;
    // Convert part2 to a number
    const index = parseInt(indexOfChild, 10);
    // Return the extracted parts as an array
    return (viewData[parentFieldId] && viewData[parentFieldId][index]) ? viewData[parentFieldId][index][childFieldId] : undefined;
  } else {
    // Return an empty array if the input doesn't match the format
    return undefined;
  }
}

export const mapCreateApiToAliasNames = (data: any, viewData: any, urlparams: Map<string, string>, createApiMapper?: apiAliasMapper[]): any => {

  createApiMapper?.forEach(mapper => {
    if (mapper.columnName.startsWith("{urlparam.")) {
      let key = mapper.columnName.substring("{urlparam.".length, mapper.columnName.length - 1);
      if (urlparams.get(key) !== null && urlparams.get(key) !== "") {
        data[mapper.mapTo] = urlparams.get(key);
      }
    } else if (viewData[mapper.columnName] !== null && viewData[mapper.columnName] !== undefined) {
      data[mapper.mapTo] = viewData[mapper.columnName];
    }
  });
  return data;
}

export const refineValuesWithPrefix = (request: string | undefined, urlparams: Map<string, string>, prefix: string): string | undefined => {
  if (request == undefined) {
    return undefined;
  }
  urlparams.forEach((value, key) => {
    request = request?.replace("{" + prefix + key + "}", value);
  });
  return request;
}

export const refineApiWithUrlParams = (endpoint: string, urlparams: Map<string, string>) => {
  urlparams.forEach((value, key) => {
    endpoint = endpoint?.replace("{" + key + "}", value);
  });
  return endpoint;
}

//this will move the data table to first page and refresh all  records
export const refreshDataTable = (refreshOnSave: any, refreshTable: Function) => {
  if (refreshOnSave === undefined || refreshOnSave) {
    refreshTable();
  }
}


export const executeExtraAction = async (recordId: string, data: any, urlparams: Map<string, string>, action: ExtraRecordLevelActions, refreshTable: Function, setOpen: Function, setError: UseFormSetError<any>) => {

  if (action.actionType === "javascript") {
    let methodName: string = action?.method!;
    if (methodName === "approveOrRejectRepoChargesRecord") {
      let fn = javascriptRowActionFns.get(methodName);
      if (fn) {

        let response: any = await fn(recordId, data, action?.args);
        if (response.status === "SUCCESS") {
          refreshTable();
          setOpen(false);
        }
      }
    } else {
      let fn = javascriptRecordActionFns.get(methodName);
      if (fn) {
        try {

          let response: any = await fn(recordId, data, action?.args, urlparams);
          if (response.status === "SUCCESS") {
            refreshTable();
            setOpen(false);
          }
        } catch (err: any) {
          if (err?.errorMessages && err?.errorMessages.length > 0) {

            err?.errorMessages.forEach((errorMessage: any) => {
              let errField = errorMessage.field;
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              },
                { shouldFocus: true });
            });
          }
        }
      }
    }
  } else if (action.actionType === "downloadFileUsingUrl") {
    const downloadRepoKitURL = refineApiWithUrlParams(action?.args[0], urlparams);
    const fileName = refineApiWithUrlParams(action?.args[1], urlparams);
    downloadCall('GET', downloadRepoKitURL, fileName, null, 'base64');
  }
}

export const convertToDouble = (stringValue: string): number | null => {
  // Check for null or empty string
  if (stringValue === null || stringValue.toString().trim() === "") {
    return null; // Return null or appropriate value for your use case
  }

  // Remove leading and trailing whitespace
  stringValue = stringValue.toString().trim();

  // Check for invalid characters
  if (/[^0-9+-.]/.test(stringValue)) {
    return NaN; // Return NaN or appropriate value for your use case
  }

  // Parse the string to double
  const doubleValue = parseFloat(stringValue);

  return doubleValue;
}

export const handleOnBlurOnField = (field: Field, setError: UseFormSetError<any>, setValue: UseFormSetValue<any>, editForm: Field[], getValues: UseFormGetValues<any>, urlparams: Map<string, string>, input: any) => {
  if (field?.actions) {
    field?.actions.filter(action => action.executeOn === "onBlur")
      .forEach(action => {
        action.operations.forEach(operation => executeFieldLevelOperation(field, setError, setValue, editForm, getValues, urlparams, input, operation));
      })
  }
}

export const executeApiCall = async (field: Field, editForm: Field[], getValues: UseFormGetValues<any>, api: string, method: string, urlparams: Map<string, string>, payload?: any): Promise<Response | undefined> => {

  if (api === undefined || api === "") {
    return Promise.resolve(undefined);
  }

  let endpoint = `${api}`;


  endpoint = fillUpWithFieldValuesInApi(field, endpoint, editForm, getValues, false);
  endpoint = refineApiWithUrlParams(endpoint, urlparams);


  return GetRequest(replaceWithCurrentApiVersion(endpoint), 'json', true).then((res: any) => {
    return res;
  }).catch((error: Error) => {
    return Promise.reject(error);
  });
}

const getIndexOfChildField = (fieldId: string): number => {
  // Use regular expression to match and extract the parts
  const regex = /([^\[\]]+)\[(\d+)\]\.([^\[\].]+)/;
  const match = fieldId.match(regex);

  // Check if the input matches the expected format
  if (match) {
    const [, , indexOfChild,] = match;
    // Convert part2 to a number
    return parseInt(indexOfChild, 10);
  } else {
    return 0;
  }
}

const skipFieldOperation = (field: Field, criteria: string | undefined, formValues: any, input: any): boolean => {
  let executionCriteria = criteria;
  if (field.field.includes(".")) {
    executionCriteria = executionCriteria?.replaceAll("{currentIndex}", "" + getIndexOfChildField(field.field));
  }
  try {
    if (executionCriteria) {
      return !eval(executionCriteria);
    }
  } catch (err) {
    console.error(err);
  }

  return false;
}

const executeFieldLevelOperation = async (field: Field, setError: UseFormSetError<any>, setValue: UseFormSetValue<any>, editForm: Field[], getValues: UseFormGetValues<any>, urlparams: Map<string, string>, input: any, nextOperation: FieldLevelActionOperation) => {

  if (skipFieldOperation(field, nextOperation.executionCriteria, getValues(), input)) {
    return;
  }

  if (nextOperation.name === "api-call") {
    executeApiCall(field, editForm, getValues, nextOperation.api!, nextOperation.method!, urlparams)
      .then((data) => {
        if (nextOperation.operations && nextOperation.operations.length > 0) {
          nextOperation.operations.forEach(operation => {
            executeFieldLevelOperation(field, setError, setValue, editForm, getValues, urlparams, data, operation);
          });
        }
      })
      .catch((error: Error) => {

        error.message = nextOperation.errorMessage ?? "Failed to fetch details!"
        setError(field.field, error);
      });
  }

  else if (nextOperation.name === "populate-form") {

    nextOperation.mappings?.forEach(mapping => {
      let fieldId = mapping.key.replaceAll("{currentIndex}", "" + getIndexOfChildField(field.field));

      const temp = eval(mapping.value);
      if (typeof temp === "number") {
        setValue(fieldId, temp.toString());
      } else {
        setValue(fieldId, temp);
      }

    });


    if (nextOperation.operations && nextOperation.operations.length > 0) {
      nextOperation.operations.forEach(operation => {
        executeFieldLevelOperation(field, setError, setValue, editForm, getValues, urlparams, input, operation);
      });

    }

  }

  else if (nextOperation.name === "set-error") {
    nextOperation.mappings?.forEach(mapping => {
      let fieldId = mapping.key.replaceAll("{currentIndex}", "" + getIndexOfChildField(field.field));
      setError(fieldId, {
        type: "focus",
        message: eval(mapping.value),
      });
    });

    if (nextOperation.operations && nextOperation.operations.length > 0) {
      nextOperation.operations.forEach(operation => {
        executeFieldLevelOperation(field, setError, setValue, editForm, getValues, urlparams, input, operation);
      });
    }
  }

}

export const fillUpWithFieldValuesInApi = (currentField: Field, api: string, editForm: Field[], getValues: UseFormGetValues<any>, isChildForm: boolean): string => {

  let response = api;
  const vals = getValues();

  editForm?.forEach((field: any) => {

    let prefix = "";

    if (isChildForm) {
      prefix = currentField.field.split(".")[0] + ".";
    }

    response = response.replaceAll("{" + field.field + "}", (isChildForm || field.isChildForm) ? eval("vals." + currentField.field) : vals[field.field]);

    if (field.isChildForm && !isChildForm && response.includes("{")) {
      response = fillUpWithFieldValuesInApi(currentField, response, field.editFields!, getValues, true);
    }

  });

  return response;
}

export const filterNonUpdatableFields = (data: any, formSchema: Field[]): any => {
  let editPayload: any = { ...data };
  let readOnlyFields = formSchema
    .filter((x) => x.updatable === false)
    .map(({ field }) => field);
  Object.keys(data).forEach((key, index) => {
    if (readOnlyFields.includes(key)) {
      delete editPayload[key];
    }
  });
  return editPayload;
}

export const filterNonCreatableFields: any = (data: any, formSchema: Field[]) => {
  let editPayload: any = { ...data };
  let readOnlyFields = formSchema
    .filter((x) => x.creatable === false)
    .map(({ field }) => field);
  Object.keys(data).forEach((key, index) => {
    if (readOnlyFields.includes(key)) {
      delete editPayload[key];
    }
  });
  return editPayload;
};

export const getAction = (userAccessLevel: AccessLevel, viewPageBluPrint: string, moduleCode: string, urlparams: Map<string, string>, actionInfo?: ActionInfo, displayName?: string, onSuccess?: (value: any) => void) => {
  return actionInfo?.type === "modal" ? (
    <CustomRecordDetailModal
      viewPageBluPrint={viewPageBluPrint}
      title={actionInfo?.title ?? ""}
      platformAction={actionInfo?.launchMode}
      blueprintApi={actionInfo?.blueprintApi ?? ""}
      actionName={displayName ?? ""}
      isCreateFlow={actionInfo?.launchMode === "Create" || actionInfo?.launchMode === "CreateWithContext"}
      userAccessLevel={userAccessLevel}
      moduleCode={moduleCode}
      allowEdits={
        actionInfo?.launchMode === "Create" ||
        actionInfo?.launchMode === "CreateWithContext" ||
        actionInfo?.launchMode === "Edit"
      }
      urlparams={urlparams}
      onSuccess={onSuccess}
    />
  ) : (
    <></>
  );
};


export const handleLoanNumberLookUp = (
  fieldValue: string,
  lookUpField: string,
  lookupUrl: string
) => {

  lookupUrl = lookupUrl.replace("{loanNo}", fieldValue);
  return new Promise((resolve, reject) => {
    GetRequest(lookupUrl, 'json', true).then((response) => {
      resolve(response[lookUpField]);
    }).catch((error) => {
      //Custom error message
      error.message = "Failed to fetch details!"
      reject(error);
    });

  });
};


export const dataTypeHandling = (temp: any, editForm: any) => {

  // This needs to be done for validation purpose - eg : 123 !== "123" according to validator
  for (let s in temp) {
    if (typeof temp[s] === "number") {
      const field = editForm.find((item: any) => item.field === s);
      if (field?.fieldType === 'textBox') {

        temp[s] = temp[s].toString();
      }
    }
  }

  return temp;
}